<script lang="ts">
  import type { Snippet } from "svelte"
  import type { HTMLAttributes } from "svelte/elements"
  import { type TransitionConfig } from "svelte/transition"
  import Ellipse from "./ellipse.svg?icon"

  let {
    transition = () => ({}),
    children,
    ...props
  }: {
    transition?: (node: Element) => TransitionConfig
    children?: Snippet
  } & HTMLAttributes<HTMLDivElement> = $props()

  const backdropClasses =
    "pointer-events-none absolute inset-0 flex h-full w-full items-center justify-center opacity-40"
  const backdropBeforeClasses =
    "before:absolute before:top-[1px] before:aspect-[336/389] before:h-[calc(100%-2px)] before:w-auto before:shadow-[0px_0px_0_100vmax_black]"
  const backdropAfterClasses =
    "after:absolute after:top-0 after:aspect-[336/389] after:h-full after:w-auto after:bg-black"
</script>

<div
  {...props}
  class={`relative flex h-full w-full items-center justify-center ${props.class}`}
  transition:transition
>
  <div class={`backdrop ${backdropClasses} ${backdropBeforeClasses} ${backdropAfterClasses}`}></div>
  <div class="frame aspect-[336/389] h-full w-auto transition-[color]">
    <Ellipse />
  </div>

  {#if children}
    <div class="absolute left-1/2 flex h-full w-full -translate-x-1/2">
      {@render children()}
    </div>
  {/if}
</div>

<style lang="postcss">
  .backdrop::after {
    mask:
      linear-gradient(to right, #000, #000),
      url("./ellipse-filled.svg") center / auto 100% no-repeat;
    mask-composite: exclude;
  }

  .frame {
    mask: linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.29));

    & > :global(*) {
      @apply h-full w-full;
    }
  }
</style>
